<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm Tống Đạt Viên</div>
      <div v-else>Chỉnh sửa Tống Đạt Viên</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm Tống Đạt Viên'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Ảnh đại diện</label>
            <div class="p-col-8">
              <FileUpload
                name="avatar"
                @select="onFileSelect($event)"
                mode="basic"
                chooseLabel="Chọn ảnh đại diện"
              >
              </FileUpload>
              <img
                :src="this.avatar_img"
                style="padding:10px; max-height:200px"
              />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Chọn Tỉnh tống đạt</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedState" :options="this.listState" 
              optionLabel="name" placeholder="Chọn 1 hoặc nhiều tỉnh(không bao gồm HCM)" :filter="true">
              </MultiSelect>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã Tống Đạt Viên*</label>
            <div class="p-col-8">
              <InputText v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã Tống Đạt Viên" />
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Chọn khu vực hoạt động*</label>
            <div class="p-col-8">
              <Dropdown id="area_id" :showClear="true" :filter="true"
              v-model="area_id" :options="list_area" optionLabel="code"
              placeholder="Chọn 1 khu vực"/>
              <small
                v-if="validationErrors && validationErrors['area_id']"
                class="p-invalid"
              >{{validationErrors['area_id']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tên Tống Đạt Viên*</label>
            <div class="p-col-8">
              <InputText v-model="fullname"  id="fullname" type="text" class="p-col-width" placeholder="Nhập họ và tên Tống Đạt Viên" />
              <small
                v-if="validationErrors && validationErrors['fullname']"
                class="p-invalid"
              >{{validationErrors['fullname']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Quận/ Huyện TĐV phụ trách</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedDistrict" :options="this.listDistrict" @change="onChangeDistrict($event)"
              optionLabel="name_with_state" placeholder="Chọn 1 hoặc nhiều Quận/Huyện TĐV phụ trách" :filter="true">
              </MultiSelect>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Sinh nhật</label>
            <div class="p-col-8">
              <Calendar v-model="birthday" dateFormat="dd/mm/yy" placeholder="Chọn ngày sinh nhật" :showIcon="true"/>    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Phường TĐV phụ trách</label>
            <div class="p-col-8">
              <!-- :disabled="this.disabledWard" -->
              <MultiSelect key="keyWardSelect" v-model="selectedWard" :options="this.listWard" 
              optionLabel="name_with_district" placeholder="Chọn 1 hoặc nhiều Phường TĐV phụ trách" :filter="true">
              </MultiSelect>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Ngày vào làm việc</label>
            <div class="p-col-8">
              <Calendar v-model="join_date" dateFormat="dd/mm/yy" placeholder="Chọn ngày vào làm việc" :showIcon="true"/>    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">ĐPV quản lý*</label>
            <div class="p-col-8">
              <Dropdown id="dpv_id" :showClear="true" :filter="true"
                v-model="dpv_id" :options="list_user_dpv" optionLabel="fullname"
                placeholder="Chọn 1 ĐPV quản lý"/>
                <small
                  v-if="validationErrors && validationErrors['dpv_id']"
                  class="p-invalid"
                >{{validationErrors['dpv_id']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mật khẩu*</label>
            <div class="p-col-8">
              <InputText v-model="password" :type="passwordType" placeholder="Nhập mật khẩu"></InputText>
              <i v-if="passwordType == 'text'" class="pi pi-eye" @click="switchVisibility" 
              style="position: absolute;margin-left: -30px;margin-top: 10px;"/>
              <i v-else class="pi pi-eye-slash" @click="switchVisibility"
              style="position: absolute;margin-left: -30px;margin-top: 10px;"/>
              <small
                v-if="validationErrors && validationErrors['password']"
                class="p-invalid"
              >{{validationErrors['password']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số điện thoại*</label>
            <div class="p-col-8">
              <InputText v-model="phone" :disabled="mode == 'edit'"  id="phone" type="text" class="p-col-width" placeholder="Nhập số điện thoại" />
              <small
                v-if="validationErrors && validationErrors['phone']"
                class="p-invalid"
              >{{validationErrors['phone']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Trạng thái</label>
            <div class="p-col-8">
              <Checkbox v-model="active" :binary="true" /> Kích hoạt
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Email*</label>
            <div class="p-col-8">
              <InputText v-model="email"  id="email" type="text" class="p-col-width" placeholder="Nhập email" />
              <small
                  v-if="validationErrors && validationErrors['email']"
                  class="p-invalid"
              >{{validationErrors['email']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
import DataServices from '@/core/DataServices'
import Config from '../../../config/index'
import moment from "moment-timezone";
import gql from "graphql-tag";
import graphql from "@/views/admin/common/graphql";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      keyWardSelect: 0,
      validationErrors: {},
      formMode: this.mode,
      avatar_img: '',
      list_area: [],
      area_id: null,
      code: '',
      password: '',
      fullname: '',
      passwordType: 'password',
      birthday: '',
      active: false,
      join_date: '',
      address: '',
      phone: '',
      email: '',
      email_old: '',
      list_user_dpv: [],
      dpv_id: '',
      list_user_tdv: [],
      users_account_id: '',
      selectedState: [],
      listState: [],
      selectedDistrict: [],
      listDistrict: [],
      selectedWard: [],
      listWard: [],
      disabledWard: true
    }
  },
  mounted() {
    this.getWard([])
    if (this.$route.params.id !== undefined) {
      this.user_tdv_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    async onChangeDistrict(e) {
      console.log('e', e)
      this.listWard = []
      this.selectedWard = []
     
      if (e.value.length > 0) {
        await this.getWard(e.value);
      } else {
        //this.disabledWard = true
        await this.getWard([]);
      }
       this.keyWardSelect++
    },
    async getWard(list_district) {
      var query = ''
      if (list_district.length > 0) {
        var list_dis = []
        for (let i = 0; i < list_district.length; i++) {
          const e = list_district[i];
          list_dis.push(e.id)
        }
         query = `query MyQuery($list_dis: [Int!]) {
          ward(where: {district_id: {_in: $list_dis}}) {
            id
            name_with_district
          }
        }`
        
      } else {
        // this.listWard = []
        // this.disabledWard = true
        query = `query MyQuery {
          ward(where: {state_merger: {id: {_eq: ${this.$constants.STATE_ID_HCM}}}}) {
            id
            name_with_district
          }
        }`
      }

      await this.$apollo
          .query({
            query: gql(query),
            variables: {
              list_dis: list_dis
            }
          })
          .then(async (res) => {
            console.log('res', res)
            if (res.data.ward) {
              this.listWard = res.data.ward
              this.disabledWard = false
            } else {
              this.listWard = []
              this.disabledWard = true
            }
        })
    },
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    async onFileSelect(event) {
      var s3client = Config.s3Client();
      console.log("Upload event", event);
      for (let i = 0; i < event.files.length; i++) {
        const f = event.files[i];
        console.log("Files", f);
        
        // let fileName1 = f.name
        // let idxDot = fileName1.lastIndexOf(".") + 1;
        // let extFile = fileName1.substr(idxDot, fileName1.length).toLowerCase();
        // if ((extFile != "jpg" && extFile != "jpeg" && extFile != "png") & col.accessable == 'image/jpeg') {
        //   alert("Vui lòng chọn file jpg/jpeg hoặc png!");
        //   return
        // }

        // let fileName = f.name.split('.')[0].replace(/ /g, '')
        let fileName = Math.random().toString().slice(2)
        // console.log('filename',fileName)
        let random = Math.random().toString().slice(2)
        fileName = `${random}_${fileName}`
        s3client.uploadFile(f, fileName).then((data) => {
          console.log(data.location);
          this.avatar_img = data.location;
          //this.$forceUpdate();
        });
      }
      var that = this
      setTimeout(function () {
        // that.$store.commit("setLoading", false);
        console.log('return image', that.value)
      }, 3000)
        
      //console.log("Result", this.value[col.name]);
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------',this.selectedState)
      console.log('-------------------------------',this.selectedDistrict)
      console.log('-------------------------------',this.selectedWard)
      this.validationErrors = {};
      var that = this;
      var has_error = false
      if (this.fullname === '') {
        this.validationErrors['fullname'] = 'Vui lòng nhập tên TĐV';
        has_error = true
        this.$forceUpdate() 
      }
      if (this.$commonFuction.isEmpty(this.email)) {
        this.validationErrors['email'] = 'Vui lòng nhập email';
        has_error = true
        this.$forceUpdate()
      }else {
        if (!this.$commonFuction.validateEmailFrom(this.email)) {
          this.validationErrors['email'] = 'Vui lòng nhập đúng định dạng email';
          has_error = true
          this.$forceUpdate()
        }else {
         //check email có trùng không
          var whereEmailExist = {account: {_eq: this.email}, deleted: {_eq: false}};
          if (this.mode != 'add') {
            whereEmailExist.uid = {_neq: this.$route.params.id};
          }
          var checkEmailExist =await that.$CoreService.getObjectData('accounts',whereEmailExist);
          console.log("checkEmailExist");
          console.log(checkEmailExist);
          if (checkEmailExist){
            this.validationErrors['email'] = 'Email này đã tồn tại';
            has_error = true
            this.$forceUpdate()
          }
        }
      }

      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã TĐV';
        has_error = true
        this.$forceUpdate() 
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            users(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã TĐV bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: uuid) {
            users(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã TĐV bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }
      }
      if (this.phone === '') {
        this.validationErrors['phone'] = 'Vui lòng nhập số điện thoại';
        has_error = true
        this.$forceUpdate() 
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($phone: String) {
            users(where: {phone: {_like: $phone}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                phone: this.phone
              }
            })
            .then(async (res) => {
              if (res.data.users.length > 0) {
                this.validationErrors['phone'] = 'Số điện thoại đã có người sử dụng';
                has_error = true 
                this.$forceUpdate() 
              }
            })
        } /*else {
          let query = `query MyQuery($phone: String, $id: uuid) {
            users(where: {phone: {_like: $phone}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                phone: this.phone,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['phone'] = 'Số điện thoại đã có người sử dụng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }*/
      }
      if (this.dpv_id == null || this.dpv_id == '') {
        this.validationErrors['dpv_id'] = 'Vui lòng chọn ĐPV quản lý';
        has_error = true
        this.$forceUpdate() 
      }
      if (this.area_id == null) {
        this.validationErrors['area_id'] = 'Chọn khu vực hoạt động';
        has_error = true
        this.$forceUpdate() 
      }
      if (this.mode == 'add') {
        if (this.password === '') {
          this.validationErrors['password'] = 'Vui lòng nhập mật khẩu';
          has_error = true
          this.$forceUpdate() 
        }  
      }else {
        if (this.email_old.trim() != this.email.trim()){
          //Nếu email cũ và email mới khác nhau thì nhập lại
          if (this.password === '') {
            this.validationErrors['password'] = 'Vui lòng nhập mật khẩu';
            has_error = true
            this.$forceUpdate()
          }
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_user_tdv = {}
        data_user_tdv['fullname'] = this.fullname
        data_user_tdv['code'] = this.code
        data_user_tdv['dpv_id'] = this.dpv_id.id
        data_user_tdv['avatar'] = this.avatar_img
        data_user_tdv['area_id'] = this.area_id.id
        data_user_tdv['address'] = this.address
        data_user_tdv['active'] = this.active
        data_user_tdv['phone'] = this.phone
        data_user_tdv['email'] = this.email
        /*data_user_tdv['join_date'] = moment(this.join_date).add(1, 'days')
        data_user_tdv['birthday'] = moment(this.birthday).add(1, 'days')*/
      data_user_tdv['join_date'] = (!this.$commonFuction.isEmpty(this.join_date)) ? moment(this.join_date).add(1, 'days') : null
      data_user_tdv['birthday'] = (!this.$commonFuction.isEmpty(this.birthday)) ? moment(this.birthday).add(1, 'days'): null


      var data_item= []

        for (let i = 0; i < this.selectedState.length; i++) {
          const item = this.selectedState[i]
          var data_item_item= {}
          data_item_item['state_id'] = item.id
          data_item.push(data_item_item)
        }
        var data_user_tdv_item = {}
        data_user_tdv_item['data'] = data_item
        data_user_tdv['users_states'] = data_user_tdv_item

        var data_item1= []

        for (let i = 0; i < this.selectedDistrict.length; i++) {
          const item1 = this.selectedDistrict[i]
          var data_item_item1= {}
          data_item_item1['district_id'] = item1.id
          data_item1.push(data_item_item1)
        }
        var data_user_tdv_item1 = {}
        data_user_tdv_item1['data'] = data_item1
        data_user_tdv['users_districts'] = data_user_tdv_item1

        var data_item2= []

        for (let i = 0; i < this.selectedWard.length; i++) {
          const item2 = this.selectedWard[i]
          var data_item_item2= {}
          data_item_item2['ward_id'] = item2.id
          data_item2.push(data_item_item2)
        }
        var data_user_tdv_item2 = {}
        data_user_tdv_item2['data'] = data_item2
        data_user_tdv['users_wards'] = data_user_tdv_item2

        console.log('sfdsdsd', data_user_tdv)
      return data_user_tdv
    },
    async analyzeDataEdit() {
      var data_user_tdv = {}
        data_user_tdv['fullname'] = this.fullname
        data_user_tdv['code'] = this.code
        data_user_tdv['dpv_id'] = this.dpv_id.id
        data_user_tdv['avatar'] = this.avatar_img
        data_user_tdv['area_id'] = this.area_id.id
        data_user_tdv['address'] = this.address
        data_user_tdv['active'] = this.active
        data_user_tdv['phone'] = this.phone
        data_user_tdv['email'] = this.email
        /*data_user_tdv['join_date'] = moment(this.join_date).add(1, 'days')
        data_user_tdv['birthday'] = moment(this.birthday).add(1, 'days')*/
      data_user_tdv['join_date'] = (!this.$commonFuction.isEmpty(this.join_date)) ? moment(this.join_date).add(1, 'days') : null
      data_user_tdv['birthday'] = (!this.$commonFuction.isEmpty(this.birthday)) ? moment(this.birthday).add(1, 'days'): null

      return data_user_tdv
    },
    async analyzeDataEditItem() {
      var data_item= []
      for (let i = 0; i < this.selectedState.length; i++) {
          const item = this.selectedState[i]
          var data_item_item= {}
          data_item_item['user_id'] = this.user_tdv_id
          data_item_item['state_id'] = item.id
          data_item.push(data_item_item)
        }
      return data_item
    },
    async analyzeDataEditItem1() {
      var data_item= []
      for (let i = 0; i < this.selectedDistrict.length; i++) {
          const item = this.selectedDistrict[i]
          var data_item_item= {}
          data_item_item['user_id'] = this.user_tdv_id
          data_item_item['district_id'] = item.id
          data_item.push(data_item_item)
        }
      return data_item
    },
    async analyzeDataEditItem2() {
      var data_item= []
      for (let i = 0; i < this.selectedWard.length; i++) {
          const item = this.selectedWard[i]
          var data_item_item= {}
          data_item_item['user_id'] = this.user_tdv_id
          data_item_item['ward_id'] = item.id
          data_item.push(data_item_item)
        }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      /*console.log("dddddddddddddddddddddddd")
      var test =1 ;
      if (test ==1 ){
        return false;
      }*/
      var that = this;
      var email = this.email;
      var password = this.password;
      var fullname = this.fullname;
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_user_tdv = await this.analyzeData()

        // TRIGGER HASURA TO CALL FIREBASE FUNCTION CREATE USER
        let phone = this.phone;
        phone = phone.substring(1)
        phone = phone.replace(' ', '');
        phone = "+84" + phone;
        let queryUserPhone = `mutation MyMutation {
                createUserPhone(phone: "${phone}", fullname: "${this.fullname}") {
                  uid
                }
              }`;
        await this.$apollo.mutate({
          mutation: gql(queryUserPhone)
        }).then(async (res) => {
          // console.log('=========> createUser: ', res)
          var firebaseID = res.data.createUserPhone.uid;
          if (firebaseID) {
            var dataInsert = that.$commonFuction.convertJsonObject(data_user_tdv);
            let insertDataAccount = {
              'id': firebaseID,
              //'uid': returning.id,
              'account': that.phone,
              'type': 'PHONE',
              'role': 'tdv'
            }
            dataInsert.users_account = {data: that.$commonFuction.convertJsonObject(insertDataAccount)};
            await that.$apollo.mutate({
              mutation: DataServices.insertData('users'),
              variables: {
                'objects': dataInsert
              }
            }).then(async (resUser) => {
              // console.log('TAO THANH CONG ACCOUNT', firebaseID)
              if (resUser.data.insert_users.returning[0].id) {
                var idUser = resUser.data.insert_users.returning[0].id;
                let update_variables = {
                  'data_update': {
                    'role': 'tdv'
                  },
                  'where_key': {
                    'uid': {'_eq': idUser},
                    'id': {'_eq': firebaseID},
                  }
                };
                await that.$apollo.mutate({
                  mutation: DataServices.updateData('accounts'),
                  variables: update_variables
                }).then(() => {

                  //Tạo account email
                  this.createUserEmail(email,fullname,password,idUser)
                  that.$toast.add({
                    severity: 'success',
                    summary: 'Thành công',
                    detail: 'Tạo tài khoản thành công',
                    life: 3000
                  })
                  that.$router.push({path: '/admin/list-users_tdv'});
                  /*setTimeout(function () {
                    // that.$store.commit("setLoading", false);
                    location.href = '/admin/list-users_tdv'
                  }, 100)*/
                }).catch((error) => {
                  that.$toast.add({
                    severity: 'error',
                    summary: 'Thất bại',
                    detail: 'Tạo dữ liệu gặp vấn đề',
                    life: 3000
                  })
                  console.error('ERROR: ', error)
                })
              }
            }).catch((error) => {
              that.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
              console.error('ERROR: ', error)
            })
          }
        }).catch((error) => {
          console.error('ERROR ', error)
         /* this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Nhập số điện thoại chính xác', life: 3000 })
          // XÓA RECORD TRONG USERS VÌ CHƯA CÓ FIREBASEID
          this.$apollo.mutate({
            mutation: DataServices.deleteData('users'),
            variables: {
              where_key: {
                id: {'_eq': returning.id}
              }
            }
          })*/
        });
        //

/*

        var query = `mutation MyMutation($objects: [users_insert_input!]!) {
            insert_users(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_user_tdv]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              // await this.uploadImages(returning.id);
              // TRIGGER HASURA TO CALL FIREBASE FUNCTION CREATE USER
              let phone = this.phone;
              phone = phone.substring(1)
              phone = phone.replace(' ', '');
              phone = "+84" + phone;
              let query = `mutation MyMutation {
                createUserPhone(phone: "${phone}", fullname: "${this.fullname}") {
                  uid
                }
              }`;
              await this.$apollo.mutate({
                mutation: gql(query)
              }).then(async (res) => {
                // console.log('=========> createUser: ', res)
                var firebaseID = res.data.createUserPhone.uid;
                if (firebaseID) {
                  let insertData = {
                    'id': firebaseID,
                    'uid': returning.id,
                    'account': this.phone,
                    'type': 'PHONE',
                    'role': 'tdv'
                  }
                  await this.$apollo.mutate({
                    mutation: DataServices.insertData('accounts'),
                    variables: {
                      'objects': insertData
                    }
                  }).then(async () => {
                    // console.log('TAO THANH CONG ACCOUNT', firebaseID)
                    let update_variables = {
                      'data_update': {
                        'role': 'tdv'
                      },
                      'where_key': {
                        'id': {'_eq': firebaseID}
                      }
                    };
                    await this.$apollo.mutate({
                      mutation: DataServices.updateData('accounts'),
                      variables: update_variables
                    }).then(() => {
                      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo tài khoản thành công', life: 3000 })
                      setTimeout(function () {
                        // that.$store.commit("setLoading", false);
                        location.href = '/admin/list-users_tdv'
                      }, 3000)
                    }).catch((error) => {
                      this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                      console.error('ERROR: ', error)
                    })
                  }).catch((error) => {
                    this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                    console.error('ERROR: ', error)
                  })
                }
              }).catch((error) => {
                console.error('ERROR ', error)
                this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Nhập số điện thoại chính xác', life: 3000 })
                // XÓA RECORD TRONG USERS VÌ CHƯA CÓ FIREBASEID
                this.$apollo.mutate({
                  mutation: DataServices.deleteData('users'),
                  variables: {
                    where_key: {
                      id: {'_eq': returning.id}
                    }
                  }
                })
              });
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })*/
      } else {
        let data_user_tdv_update = await this.analyzeDataEdit();
        delete data_user_tdv_update.phone;
        let data_user_tdv_item = await this.analyzeDataEditItem()
        let data_user_tdv_item1 = await this.analyzeDataEditItem1()
        let data_user_tdv_item2 = await this.analyzeDataEditItem2()
        let query = `mutation MyMutation($users_id: uuid!, $users_update: users_set_input
        , $objects: [users_state_insert_input!]!, $objects1: [users_district_insert_input!]!
        , $objects2: [users_ward_insert_input!]!) {
          update_users(where: {id: {_eq: $users_id}}, _set: $users_update) {
            affected_rows
            returning {
              id
              fullname
            }
          }
          delete_users_state(where: {user_id: {_eq: $users_id}}) {
            affected_rows
          }
          insert_users_state(objects: $objects) {
            affected_rows
          }
          delete_users_district(where: {user_id: {_eq: $users_id}}) {
            affected_rows
          }
          insert_users_district(objects: $objects1) {
            affected_rows
          }
          delete_users_ward(where: {user_id: {_eq: $users_id}}) {
            affected_rows
          }
          insert_users_ward(objects: $objects2) {
            affected_rows
          }
        }`;
        var user_id = this.user_tdv_id;
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              users_id: this.user_tdv_id,
              users_update: data_user_tdv_update,
              objects: data_user_tdv_item,
              objects1: data_user_tdv_item1,
              objects2: data_user_tdv_item2
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              //check khác email hiện tại thì tạo account mới
              var email = (that.email) ? that.email.trim():'';
              var email_old = (that.email_old) ? that.email_old.trim():'';
              if (email != email_old){
                console.log("tessssssssssssssssssssss")
                //Tạo account mới và xóa account cũ
                this.createUserEmail(email,fullname,password,this.user_tdv_id)
                //Xóa account cũ || bật cờ update bảng account tự động xóa account firebase
                if (!this.$commonFuction.isEmpty(email_old)){
                var accountUpdate = {
                  'deleted': true,
                }
                var queryUpdateAccounts = `
                    mutation update_users_multil($accounts_object: accounts_set_input) {
                      update_accounts(where: { uid: {_eq: "${this.user_tdv_id}"},account: {_eq: "${email_old}"},type: {_eq: "EMAIL"}}, _set: $accounts_object) {
                        affected_rows
                        returning {
                          id
                        }
                      }
                    }
              `;
                var variables = {
                  accounts_object: accountUpdate,
                };
                this.$apollo.mutate({
                  mutation: gql(queryUpdateAccounts),
                  variables: variables
                }).then(() => {
                  //console.log(res)
                })
                }

              }else {
                if (!that.$commonFuction.isEmpty(password)){
                  //console.log("Change pass word")
                  var whereAccount = {account: {_eq: email}, deleted: {_eq: false},uid: {_eq: user_id}};
                  var getAccount =await that.$CoreService.getObjectData('accounts',whereAccount);
                  if (getAccount){
                    //nếu tồn tại password thì đổi password
                    let query = `mutation MyMutation {
                  changePassword(password: "${password}", uid: "${getAccount.id}") {
                    uid
                  }
                }`;
                    await this.$apollo.mutate({
                      mutation: gql(query)
                    }).then(() => {
                    }).catch(() => {
                    })
                  }

                }
              }

              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Cập nhật thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              that.$router.push({path: '/admin/list-users_tdv'});
              /*setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-users_tdv'
              }, 100)*/
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Cập nhật gặp vấn đề",
                life: 3000
              });
            }
          })
      }
    },
    async createUserEmail(email,fullname,password,uid) {

      let queryCreteUser = `mutation MyMutation {
                createUser(email: "${email}", fullname: "${fullname}", password: "${password}") {
                  uid
                }
              }`;
      await this.$apollo.mutate({
        mutation: gql(queryCreteUser)
      }).then(async (res) => {
        var firebaseID = res.data.createUser.uid;
        if (firebaseID) {
          //var dataInsert = this.$commonFuction.convertJsonObject(data_user_dpv);
          let insertDataAccount = {
            'id': firebaseID,
            'uid': uid,
            'account': this.email,
            'type': 'EMAIL',
            'role': 'tdv'
          }
          //dataInsert.users_account = {data: this.$commonFuction.convertJsonObject(insertDataAccount)};
          await this.$apollo
              .mutate({
                //mutation: gql(queryUsers),
                mutation: DataServices.insertData('accounts'),
                variables: {
                  objects: insertDataAccount
                }
              })
              .then(async (resUser)  => {
                console.log("Thành công tạo user email:",resUser)
              }).catch(async error => {
                this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                console.error('ERROR: ', error)
              });
        }
      })
    },
  },
  apollo: {
    area: {
      query() {
        let query = graphql.GET_AREA_COMMON
        return gql(query);
      },
      update(data) {
        if(data.area){
          this.list_area = data.area
        }
      },
      fetchPolicy: "network-only"
    },
    user_dpv: {
      query() {
        let query = `
          query MyQuery {
            users(where: {users_account: {role: {_eq: "dpv"}}}) {
              id
              fullname
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.users){
          this.list_user_dpv = data.users
        }
      },
      fetchPolicy: "network-only",
    },
    state: {
      query() {
        let query = `
          query MyQuery {
            state(where: {type: {_eq: ${this.$constants.TYPE_STATE.OUTSIDE}}}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.state){
          this.listState = data.state
        }
      },
      fetchPolicy: "network-only"
    },
    district: {
      query() {
        let query = `
          query MyQuery {
            district(where: {state: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}}}) {
              id
              name_with_state
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.district){
          this.listDistrict = data.district
        }
      },
      fetchPolicy: "network-only"
    },
    user_tdv: {
      query() {
        let query = `
          query MyQuery($id: uuid) {
            users(where: {id: {_eq: $id}}) {
              avatar
              fullname
              phone
              email
              birthday
              code
              address
              active
              join_date
              users_dpv {
                id
                fullname
              }
              areas {
                id
                code
              }
              users_account {
                id
              }
              users_states {
                state {
                  id
                  name
                }   
              }
              users_districts {
                district {
                  id
                  name_with_state
                }   
              }
              users_wards {
                ward {
                  id
                  name_with_district
                }   
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.users){
          this.list_user_tdv = data.users
          this.fullname = this.list_user_tdv[0].fullname
          this.birthday = (this.list_user_tdv[0].birthday) ? (new Date(this.list_user_tdv[0].birthday)):''
          this.join_date = (this.list_user_tdv[0].join_date) ? (new Date(this.list_user_tdv[0].join_date)) :''
          this.avatar_img = this.list_user_tdv[0].avatar
          this.phone = this.list_user_tdv[0].phone
          this.email = this.list_user_tdv[0].email
          this.email_old = this.list_user_tdv[0].email
          this.code = this.list_user_tdv[0].code
          this.address = this.list_user_tdv[0].address
          this.active = this.list_user_tdv[0].active
          this.dpv_id = this.list_user_tdv[0].users_dpv
          this.area_id = this.list_user_tdv[0].areas
          this.users_account_id = this.list_user_tdv[0].users_account.id
          if (this.list_user_tdv[0].users_states.length >0) {
            for (let i = 0; i < this.list_user_tdv[0].users_states.length; i++) {
              const e = this.list_user_tdv[0].users_states[i];
              this.selectedState.push({id: e.state.id, name: e.state.name, __typename: "state"})
            }
          }
          if (this.list_user_tdv[0].users_districts.length >0) {
            for (let i = 0; i < this.list_user_tdv[0].users_districts.length; i++) {
              const e = this.list_user_tdv[0].users_districts[i];
              this.selectedDistrict.push({id: e.district.id, name_with_state: e.district.name_with_state, __typename: "district"})
            }
            this.getWard(this.selectedDistrict)
          }
          if (this.list_user_tdv[0].users_wards.length >0) {
            for (let i = 0; i < this.list_user_tdv[0].users_wards.length; i++) {
              const e = this.list_user_tdv[0].users_wards[i];
              this.selectedWard.push({id: e.ward.id, name_with_district: e.ward.name_with_district, __typename: "ward"})
            }
          }
          console.log('-------------------------------',this.selectedState)
          console.log('-------------------------------',this.selectedDistrict)
          console.log('-------------------------------',this.selectedWard)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
